import { render, staticRenderFns } from "./VehicleOwnershipContracts.vue?vue&type=template&id=9b511e84&scoped=true&"
import script from "./VehicleOwnershipContracts.vue?vue&type=script&lang=js&"
export * from "./VehicleOwnershipContracts.vue?vue&type=script&lang=js&"
import style0 from "./VehicleOwnershipContracts.vue?vue&type=style&index=0&id=9b511e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b511e84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b511e84')) {
      api.createRecord('9b511e84', component.options)
    } else {
      api.reload('9b511e84', component.options)
    }
    module.hot.accept("./VehicleOwnershipContracts.vue?vue&type=template&id=9b511e84&scoped=true&", function () {
      api.rerender('9b511e84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/VehicleOwnershipContracts.vue"
export default component.exports